import { createFileRoute, Outlet } from "@tanstack/solid-router";

export const Route = createFileRoute("/_dashboard/dashboard/journal-entries")({
  staticData: {
    breadcrumb: "Journal Entries",
  },
  component: () => <Outlet />,
});
